export default "__VITE_ASSET__D8H52v1f__"